import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import AppLoader from './AppLoader'

export default function PublicRoute({ children }) {
  const { isAuthenticated, isGuest, isLoading } = useAuth()

  if (isLoading) return <AppLoader />
  if (isAuthenticated || isGuest) return <Navigate to="/dashboard" replace />

  return children
}
